import { Link } from 'react-router'
import { Icon } from '../../components/Icon'
import { useUi } from '../../state/ui'

export function EmptyPane({ notFound = false }: { notFound?: boolean }) {
  const openDialog = useUi((s) => s.openDialog)
  return (
    <div className="chat-empty">
      <Icon name="message" />
      <h2>{notFound ? 'Page not found' : 'Your conversations, in one place'}</h2>
      <p>{notFound ? 'That link does not match anything in BOSS Chat.' : 'Choose a conversation or start a new message.'}</p>
      {notFound ? (
        <Link className="button primary" to="/">
          Go to your chats
        </Link>
      ) : (
        <button type="button" className="button primary" onClick={() => openDialog('new-dm')}>
          New Message
        </button>
      )}
    </div>
  )
}
